// Efecto del botón "Agregar al carrito": onda al pulsar y celebración cuando el producto entra en el carrito.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CONFETTI_COLORS = ['#121212', '#c9a86a', '#e8c4c4', '#d32f2f', '#ffffff'];
  let lastButton = null;

  document.addEventListener('pointerdown', (event) => {
    const button = event.target.closest('.product-form__submit');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    lastButton = button;
    if (reduceMotion) return;

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2;
    const ripple = document.createElement('span');
    ripple.className = 'atc-ripple';
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${event.clientX - rect.left - size / 2}px`;
    ripple.style.top = `${event.clientY - rect.top - size / 2}px`;
    button.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
  });

  // Envío con teclado (Enter) sin pointerdown
  document.addEventListener(
    'submit',
    (event) => {
      const button = event.target.querySelector?.('.product-form__submit');
      if (button) lastButton = button;
    },
    true
  );

  function burstConfetti(button) {
    const rect = button.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + rect.height / 2;

    for (let i = 0; i < 24; i++) {
      const piece = document.createElement('span');
      piece.className = 'atc-confetti';
      piece.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      piece.style.left = `${originX}px`;
      piece.style.top = `${originY}px`;
      if (i % 3 === 0) piece.style.borderRadius = '50%';
      document.body.appendChild(piece);

      const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.3;
      const distance = 70 + Math.random() * 110;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance;
      const spin = (Math.random() - 0.5) * 720;

      piece
        .animate(
          [
            { transform: 'translate(-50%, -50%) rotate(0deg) scale(1)', opacity: 1 },
            { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${spin / 2}deg) scale(1)`, opacity: 1, offset: 0.6 },
            { transform: `translate(calc(-50% + ${dx * 1.1}px), calc(-50% + ${dy + 60}px)) rotate(${spin}deg) scale(0.6)`, opacity: 0 },
          ],
          { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' }
        )
        .finished.then(() => piece.remove());
    }
  }

  function celebrate(button) {
    if (!button || button.classList.contains('atc-success')) return;

    const label = document.createElement('span');
    label.className = 'atc-success-label';
    label.setAttribute('aria-hidden', 'true');
    label.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path class="atc-check" d="M5 12.5l4.5 4.5L19 7.5"/></svg>¡Añadido!';
    button.appendChild(label);
    button.classList.add('atc-success');

    if (!reduceMotion) {
      burstConfetti(button);
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) {
        cartIcon.classList.remove('atc-cart-bounce');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('atc-cart-bounce');
      }
    }

    setTimeout(() => {
      button.classList.remove('atc-success');
      label.remove();
    }, 2000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form' && event.source !== 'quantity-bundle') return;
      celebrate(lastButton);
    });
  });
})();
